'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const Check = () => /*#__PURE__*/React__default["default"].createElement("svg", {
  width: "50%",
  height: "auto",
  viewBox: "0 0 16 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default["default"].createElement("path", {
  d: "M1.5 4.5L6.5 9.5L15 1",
  stroke: "white",
  strokeWidth: "2"
}, /*#__PURE__*/React__default["default"].createElement("title", null, "Check Mark")));

exports.Check = Check;
